export const instance = 'ofs';
export const apiBaseUrl = 'https://api.unityerp.com/' + instance + '/';
export const reportBaseUrl = 'https://reports.unityerp.com/' + instance + '/';

export const apiRoutes = {
    STOCKCARD_PROCESS_STOCKCARD_ITEMS_CSV: apiBaseUrl + 'inventory/process-stockcard-items-csv',    

    LOGIN: apiBaseUrl + 'auth/login',
    IS_VALID_ACESS_TOKEN: apiBaseUrl + 'auth/is-valid-access-token',
    CUSTOMER_QUICK_SEARCH: apiBaseUrl + 'customers/quick-search',
    CUSTOMER_LOOKUP: apiBaseUrl + 'customers/lookup',
    CURRENCIES_LIST: apiBaseUrl + 'currencies/list',
    TAX_CODES_LIST: apiBaseUrl + 'taxes/list-codes',
    GET_TAX_RATE: apiBaseUrl + 'taxes/get-rate',
    PRODUCT_LOOKUP: apiBaseUrl + 'products/lookup',
    PRODUCT_GET_PRICE: apiBaseUrl + 'products/get-sale-price',
    CREATE_SALE_QUOTATION: apiBaseUrl + 'sales/create-quotation',
    CREATE_SALE_ORDER: apiBaseUrl + 'sales/create-order',
    CREATE_SALE_INVOICE: apiBaseUrl + 'sales/create-invoice',
    SALES_QUICK_SEARCH: apiBaseUrl + 'sales/quick-search',
    SALES_RETRIEVE_ORDER: apiBaseUrl + 'sales/retrieve-order',
    SALES_RETRIEVE_QUOTATION: apiBaseUrl + 'sales/retrieve-quotation',
    SALES_RETRIEVE_INVOICE: apiBaseUrl + 'sales/retrieve-invoice',
    UPDATE_SALE_ORDER: apiBaseUrl + 'sales/update-order',
    UPDATE_SALE_QUOTATION: apiBaseUrl + 'sales/update-quotation',
    UPDATE_SALE_INVOICE: apiBaseUrl + 'sales/update-invoice',
    COUNTRY_LIST: apiBaseUrl + 'countries/list',
    CREATE_CUSTOMER: apiBaseUrl + 'customers/create',
    RETRIEVE_CUSTOMER: apiBaseUrl + 'customers/retrieve',
    UPDATE_CUSTOMER: apiBaseUrl + 'customers/update',
    DELETE_CUSTOMER: apiBaseUrl + 'customers/delete',
    LIST_ACTIVE_LANGUAGES: apiBaseUrl + 'languages/list',
    LOAD_LANGUAGE_TERMS: apiBaseUrl + 'languages/load',
    PRODUCT_QUICK_SEARCH: apiBaseUrl + 'products/quick-search',
    PRODUCT_CREATE: apiBaseUrl + 'products/create',
    RETRIEVE_PRODUCT: apiBaseUrl + 'products/retrieve',
    PRODUCT_UPDATE: apiBaseUrl + 'products/update',
    PRODUCT_DELETE: apiBaseUrl + 'products/delete',
    PRODUCT_CATEGORIES_LIST_ALL: apiBaseUrl + 'productcategories/list-all',
    CREATE_BANK_ACCOUNT: apiBaseUrl + 'contactBankAccounts/create',
    UPDATE_BANK_ACCOUNT: apiBaseUrl + 'contactBankAccounts/update',
    DELETE_BANK_ACCOUNT: apiBaseUrl + 'contactBankAccounts/delete',
    CREATE_PRODUCT_CODE: apiBaseUrl + 'productCodes/create',
    UPDATE_PRODUCT_CODE: apiBaseUrl + 'productCodes/update',
    DELETE_PRODUCT_CODE: apiBaseUrl + 'productCodes/delete',
    PRODUCT_MEDIA_UPLOAD: apiBaseUrl + 'productMedias/upload',
    PRODUCT_MEDIA_DELETE: apiBaseUrl + 'productMedias/delete',
    PRODUCT_MEDIA_UPDATE_PRODUCT_ID: apiBaseUrl + 'productMedias/update-product-id',
    CREATE_BOM: apiBaseUrl + 'productBoms/create',
    DELETE_BOM: apiBaseUrl + 'productBoms/delete',
    LIST_PRODUCT_UOMS: apiBaseUrl + 'products/list-product-uoms',
    LOOKUP_PRODUCT_FOR_BOM: apiBaseUrl + 'products/lookup-for-bom',
    GET_BOM_COMPONENTS: apiBaseUrl + 'productBoms/get-bom-components',
    LIST_BUSINESS_UNITS: apiBaseUrl + 'customers/list-business-units',
    SALE_CHANNEL_QUICK_SEARCH: apiBaseUrl + 'salechannels/quick-search',
    SALE_CHANNEL_RETRIEVE: apiBaseUrl + 'salechannels/retrieve',
    SALE_CHANNEL_ADD_CUSTOMER: apiBaseUrl + 'salechannels/add-customer',
    SALE_CHANNEL_RETRIEVE_CUSTOMERS: apiBaseUrl + 'salechannels/retrieve-customers',
    SALE_CHANNEL_REMOVE_CUSTOMER: apiBaseUrl + 'salechannels/remove-customer',
    SALE_CHANNEL_PRODUCT_CATEGORIES: apiBaseUrl + 'salechannels/save-product-categories',
    CREATE_SALE_CHANNEL: apiBaseUrl + 'salechannels/create',
    UPDATE_SALE_CHANNEL: apiBaseUrl + 'salechannels/update',
    UPLOAD_SO: apiBaseUrl + 'printouts/upload-so',
    UPLOAD_SI: apiBaseUrl + 'printouts/upload-si',
    UPLOAD_SQ: apiBaseUrl + 'printouts/upload-sq',
    UPDATE_DOCUMENT_PRINTOUTS:apiBaseUrl + 'printouts/update-document-id',
    GET_DOCUMENT_PRINTOUTS: apiBaseUrl + 'printouts/get-printouts',
    PRODUCT_CATEGORIES_LOOKUP: apiBaseUrl + 'productcategories/lookup',
    PRODUCT_UOM_CREATE: apiBaseUrl + 'productUoms/create',
    PRODUCT_UOM_DELETE: apiBaseUrl + 'productUoms/delete',
    SALE_CHANNEL_CREATE_SPECIAL_PRICE: apiBaseUrl + 'salechannels/create-special-price',
    RETRIEVE_INVOICE: apiBaseUrl + 'sales/retrieve-invoice',
    FILTER_INVOICES: apiBaseUrl + 'sales/filter-invoices',
    DELETE_SALE_CHANNEL_PRICE: apiBaseUrl + 'salechannels/delete-price',
    TRADE_ITEMS_DESP_LOOKUP: apiBaseUrl + 'products/trade-items-desp-lookup',
    CUSTOMER_LOOKUP_FOR_SALECHANNEL: apiBaseUrl + 'customers/lookup-for-salechannel',
    LIST_SALE_PERSOPNS: apiBaseUrl + 'employees/list_from_user_role',
    GET_AUTH_USER: apiBaseUrl + 'users/get-authuser',
    TRADE_ITEM_DESP_LOOKUP:apiBaseUrl + 'products/trade-items-desp-lookup',
    CONVERT_TO_SO:apiBaseUrl + 'sales/convert-to-so',
    CONVERT_TO_SI:apiBaseUrl + 'sales/convert-to-si',
    RECEIVE_NOTIFICATIONS: apiBaseUrl + 'notifications/retrieve-notifications-unread',
    RECEIVE_NOTIFICATION_MARK_READ: apiBaseUrl + 'notifications/mark-read',
    APPROVE_DOCUMENT: apiBaseUrl + 'documents/approve',
    REJECT_DOCUMENT: apiBaseUrl + 'documents/reject',
    LIST_MILESTONES: apiBaseUrl + 'milestones/list-milestones',
    CREATE_DOCUMENT_REVISIONS: apiBaseUrl + 'documentrevisions/create',
    LIST_DOCUMENT_REVISIONS: apiBaseUrl + 'documentrevisions/list',
    GET_APPROVAL_REQUESTS: apiBaseUrl + 'users/get-approval-requests',
    APPROVE_DOCUMENTS:apiBaseUrl + 'documents/approve-selected-list',
    REJECT_DOCUMENTS:apiBaseUrl + 'documents/reject-selected-list',
    DASHBOARD_SUMMARY: apiBaseUrl + 'users/dashboard-summary',
    COPY_DOCUMENT: apiBaseUrl + 'sales/copy',
    RETRIEVE_DOCUMENT_REVISION:apiBaseUrl + 'documentrevisions/retrieve',
    RECEIPTS_QUICK_SEARCH: apiBaseUrl + 'salesReceipts/quick-search',
    RETRIEVE_OUTSTANDING_SIS: apiBaseUrl + 'sales/retrieve-outstanding-invoices',
    CREATE_SALE_RECEIPT:apiBaseUrl + 'salesReceipts/create',
    GET_CURRENCY_PREFIX:apiBaseUrl + 'currencies/get-prefix',
    SALES_RETRIEVE_RECEIPT: apiBaseUrl + 'salesReceipts/retrieve',
    RETRIEVE_BANKACCOUNTS_BY_CURRENCY_CODE: apiBaseUrl + 'bankaccounts/retrieve-by-currency-code',
    UPDATE_SALE_RECEIPT: apiBaseUrl + 'salesReceipts/update',
    VOID_RECEIPT: apiBaseUrl + 'salesReceipts/void',
    UPLOAD_SR: apiBaseUrl + 'printouts/upload-sr',
    LOCATION_QUICK_SEARCH: apiBaseUrl + 'locations/quick-search',
    STORAGECLASS_LIST:apiBaseUrl + 'storageclassifications/list',
    LOCATION_ACTIVE_LIST: apiBaseUrl + 'locations/get-active-list',
    CREATE_LOCATION: apiBaseUrl + 'locations/create',
    UPDATE_LOCATION: apiBaseUrl + 'locations/update',
    RETRIEVE_LOCATION: apiBaseUrl + 'locations/retrieve',
    LOCATION_LOOKUP:apiBaseUrl + 'locations/lookup',
    LIST_WAREHOUSES:apiBaseUrl + 'locations/get-warehouses',
    LOOKUP_LOCATIONS_BY_WH:apiBaseUrl + 'locations/lookup-by-parent',
    STOCKCARD_CREATE_FROM_LIST: apiBaseUrl + 'inventory/create-from-list',
    STOCKCARDS_QUICK_SEARCH: apiBaseUrl + 'stockcards/quick-search',
    INVENTORY_QUICK_SEARCH: apiBaseUrl + 'inventory/quick-search',
    STOCKCARDS_RETRIEVE: apiBaseUrl + 'stockcards/retrieve',
    LIST_SO_FOR_DO: apiBaseUrl + 'sales/list-so-for-do',
    RETRIEVE_LOTS:apiBaseUrl + 'inventory/retrieve-lots',
    RETRIEVE_SO_ITEMS:apiBaseUrl + 'sales/retrieve-so-items',
    LIST_DOS_FOR_SI:apiBaseUrl + 'sales/list-dos-for-si',
    GENERATE_INVOICE_FROM_DOS: apiBaseUrl + 'sales/generate-invoice-from-dos',
    GENERATE_INVOICE_FROM_GRNS: apiBaseUrl + 'purchase/generate-invoice-from-grns',
    VALIDATE_ALLOCATE_QTY_FOR_DO:apiBaseUrl + 'sales/validate-allocate-qty-for-do',
    VENDOR_QUICK_SEARCH:apiBaseUrl + 'vendors/quick-search',
    RETRIEVE_VENDOR:apiBaseUrl + 'vendors/retrieve',
    UPDATE_VENDOR:apiBaseUrl + 'vendors/update',
    CREATE_VENDOR:apiBaseUrl + 'vendors/create',
    CREATE_PURCHASE_PRICE: apiBaseUrl + 'contactPurchasePrices/create',
    DELETE_PURCHASE_PRICE: apiBaseUrl + 'contactPurchasePrices/delete',
    PURCHASE_QUICK_SEARCH:apiBaseUrl + 'purchase/quick-search',
    VENDOR_LOOKUP:apiBaseUrl + 'vendors/lookup',
    LIST_VENDOR_BUSINESS_UNITS: apiBaseUrl + 'vendors/list-business-units',
    PRODUCT_GET_PURCHASE_PRICE: apiBaseUrl + 'products/get-purchase-price',
    PRODUCT_LOOKUP_FOR_PURCHASE: apiBaseUrl + 'products/lookup-for-purchase',
    CREATE_PURCHASE_ORDER: apiBaseUrl + 'purchase/create-order',
    PURCAHSE_RETRIEVE_ORDER: apiBaseUrl + 'purchase/retrieve-order',
    CREATE_PURCHASE_INVOICE: apiBaseUrl + 'purchase/create-invoice',
    PURCAHSE_RETRIEVE_INVOICE: apiBaseUrl + 'purchase/retrieve-invoice',
    UPDATE_PURCHASE_ORDER:apiBaseUrl + 'purchase/update-order',
    UPDATE_PURCHASE_INVOICE:apiBaseUrl + 'purchase/update-invoice',
    LIST_POS_FOR_GRN: apiBaseUrl + 'purchase/list-po-for-grn',
    RETRIEVE_PO_ITEMS:apiBaseUrl + 'purchase/retrieve-po-items',
    LIST_GRNS_FOR_PI:apiBaseUrl + 'purchase/list-grns-for-pi',
    GET_INVENTORY_DETAILS: apiBaseUrl + 'inventory/get-details',
    QUICK_SEARCH_GRNS: apiBaseUrl + 'inventory/quick-search-grns',
    QUICK_SEARCH_DOS: apiBaseUrl + 'inventory/quick-search-dos',
    DEFAULT_SQ_VALIDITY_DAYS: apiBaseUrl + 'sales/get-default-quotation-validity-days',
    GET_PRODUCT_AVAILABLE_QTY: apiBaseUrl + 'inventory/get-product-available-qty',
    GET_SO_TRADE_ITEMS_FOR_PURCHASE:apiBaseUrl + 'sales/get-so-trade-items-for-purchase',
    GENERATE_PO_FOR_TRADE_ITEMS: apiBaseUrl + 'purchase/generate-po-for-trade-items',
    QUICK_SEARCH_USERS:apiBaseUrl + 'users/quick-search',
    EMPLOYEE_LOOKUP:apiBaseUrl + 'employees/lookup',
    LIST_ROLES: apiBaseUrl + 'users/list-roles',
    USER_RETRIEVE:apiBaseUrl + 'users/retrieve',
    UPDATE_USER:apiBaseUrl + 'users/update',
    CREATE_USER:apiBaseUrl + 'users/create',
    QUICK_SEARCH_COA:apiBaseUrl + 'accountItems/quick-search',
    LIST_ALL_ACCOUNT_TYPES: apiBaseUrl + 'accountTypes/list-all',
    ACCOUNT_ACTIVE_LIST:apiBaseUrl + 'accounts/get-active-list',
    UPDATE_ACCOUNT: apiBaseUrl + 'accountItems/update',
    CREATE_ACCOUNT: apiBaseUrl + 'accountItems/create',
    RETRIEVE_ACCOUNT:apiBaseUrl + 'accountItems/retrieve',
    GET_FYS: apiBaseUrl + 'accounts/get-financial-years',
    CREATE_NEW_FY: apiBaseUrl + 'accounts/create-new-fy',
    DELETE_ACCOUNT: apiBaseUrl + 'accountItems/delete',
    CREATE_VOUCHER: apiBaseUrl + 'accountItemVouchers/create',
    QUICK_SEARCH_VOUCHERS:apiBaseUrl + 'accountItemVouchers/quick-search',
    RETRIEVE_VOUCHER:apiBaseUrl + 'accountItemVouchers/retrieve',
    GET_ACCOUNTS_FOR_FY:apiBaseUrl + 'accountItems/get-accounts-for-fy',
    VOID_VOUCHER:apiBaseUrl + 'accountItemVouchers/void',
    GET_BOM_ITEM_PRICE:apiBaseUrl + 'sales/get-bom-item-price',
    RETRIEVE_META_CONFIG:apiBaseUrl + 'customers/retrieve-metas-config',
    SET_SELECTED_LANGUAGE:apiBaseUrl + 'users/set-language-code',
    GET_SALES_SUBTYPES:apiBaseUrl + 'sales/get-sales-subtypes',
    GET_PURCHASE_SUBTYPES:apiBaseUrl + 'purchase/get-purchase-subtypes',
    GET_PRODUCT_DEFAULT_UOM: apiBaseUrl + 'products/get-default-uom',
    LOOKUP_WAREHOUSE: apiBaseUrl + 'locations/lookup-locations',
    PRODUCT_LOOKUP_UNDER_LOCATION:apiBaseUrl + 'products/lookup-under-location',
    CAL_DOCUMENT_TOTAL: apiBaseUrl + 'sales/calc-total',
    GET_PRODUCT_LOCATION_QTY: apiBaseUrl + 'products/get-location-physical-qty',
    STOCKTRANSFER_CREATE: apiBaseUrl + 'stocktransfers/create',
    STOCKTRANSFER_UPDATE: apiBaseUrl + 'stocktransfers/update',
    STOCKTRANSFER_QUICK_SEARCH: apiBaseUrl + 'stocktransfers/quick-search',
    STOCKTRANSFER_RETRIEVE: apiBaseUrl + 'stocktransfers/retrieve',
    STOCKTRANSFER_PROVISIONING: apiBaseUrl + 'stocktransfers/provisioning',
    STOCKTRANSFER_CONFIRM_SENT: apiBaseUrl + 'stocktransfers/confirm-sent',
    STOCKTRANSFER_CONFIRM_RECEIVED: apiBaseUrl + 'stocktransfers/confirm-received',
    STOCKTRANSFER_CANCEL_REQUEST: apiBaseUrl + 'stocktransfers/cancel-request',
    GET_FY_BY_DATE:apiBaseUrl + 'accounts/get-fy-by-date',
    ISSUE_PROVISIONING: apiBaseUrl + 'stocktransfers/get-location-allocations-for-provisioning',
    STOCKCARD_CONFIRM_PROVISIONED: apiBaseUrl + 'stocktransfers/confirm-provisioned',
    LIST_ALL_LOCATIONS:apiBaseUrl + 'locations/list-all',
    LIST_FROM_WAREHOUSES: apiBaseUrl + 'locations/list-from-warehouses',
    LIST_TO_WAREHOUSES: apiBaseUrl + 'locations/list-to-warehouses',
    CONTACT_CATEGORIES_QUICK_SEARCH: apiBaseUrl + 'contactCategories/quick-search',
    CONTACT_CATEGORY_CREATE: apiBaseUrl + 'contactCategories/create',
    CONTACT_CATEGORY_UPDATE: apiBaseUrl + 'contactCategories/update',
    CONTACT_CATEGORY_RETRIEVE: apiBaseUrl + 'contactCategories/retrieve',
    CONTACT_CATEGORY_DELETE:apiBaseUrl + 'contactCategories/delete',
    CONTACT_CATEGORY_LIST: apiBaseUrl + 'contactCategories/get-active-list',
    SYSTEM_QUICK_SEARCH:apiBaseUrl + 'system/quick-search',
    SYSTEM_RETRIEVE:apiBaseUrl + 'system/retrieve',
    SYSTEM_UPDATE:apiBaseUrl + 'system/update',
    SYSTEM_CREATE:apiBaseUrl + 'system/create',
    CASE_UPLOAD:apiBaseUrl + 'caseUploads/upload',
    CASE_UPLOAD_REMOVE: apiBaseUrl + 'caseUploads/remove',
    GET_DEFAULT_DEBTOR_ACCOUNTS: apiBaseUrl + 'accountConfigs/get-default-debtor-accounts',
    GET_DEFAULT_CREDITOR_ACCOUNTS: apiBaseUrl + 'accountConfigs/get-default-creditor-accounts',
    GET_SALES_ITEMS_HISTORY_FOR_CUSTOMER: apiBaseUrl + 'sales/get-sale-items-history-for-customers',
    UPLOAD_DOCUMENT:apiBaseUrl + 'uploads/upload-document',
    UPLOAD_DOCUMENT_REMOVE:apiBaseUrl + 'uploads/delete-document',
    ASSETS_QUICK_SEARCH: apiBaseUrl + 'assets/quick-search',
    LIST_RFID_FOR_ASSETS: apiBaseUrl + 'assets/list-rids-for-asset',
    LIST_ASSET_CLASSIFICATIONS: apiBaseUrl + 'assets/list-asset-classifications',
    CREATE_ASSET: apiBaseUrl + 'assets/create',
    UPDATE_ASSET:apiBaseUrl + 'assets/update',
    RETRIEVE_ASSET: apiBaseUrl + 'assets/retrieve',
    RFID_QUICK_SEARCH: apiBaseUrl + 'rfids/quick-search',
    RETRIEVE_RFID: apiBaseUrl + 'rfids/retrieve',
    UPDATE_RFID:apiBaseUrl + 'rfids/update',
    CREATE_RFID:apiBaseUrl + 'rfids/create',
    UPLOAD_RFID_FILE:apiBaseUrl + 'rfids/upload-file',
    ASSET_CLASSIFICATIONS_QUICK_SEARCH: apiBaseUrl + 'assetClassifications/quick-search',
    ASSET_CLASSIFICATIONS_RETRIEVE: apiBaseUrl + 'assetClassifications/retrieve',
    ASSET_CLASSIFICATIONS_UPDATE: apiBaseUrl + 'assetClassifications/update',
    ASSET_CLASSIFICATIONS_CREATE: apiBaseUrl + 'assetClassifications/create',
    LIST_ASSET_CHILDREN_TO_ADD:apiBaseUrl + 'assets/list-asset-children-to-add',
    ADD_ASSET_CHILDREN:apiBaseUrl + 'assets/add-to-children',
    DELETE_ASSET_CHILDREN:apiBaseUrl + 'assets/delete-from-children',
    ASSET_PROTOCOLS_QUICK_SEARCH: apiBaseUrl + 'assetProtocols/quick-search',
    ASSET_PROTOCOL_CREATE: apiBaseUrl + 'assetProtocols/create',
    ASSET_PROTOCOL_UPDATE: apiBaseUrl + 'assetProtocols/update',
    ASSET_PROTOCOL_RETRIEVE: apiBaseUrl + 'assetProtocols/retrieve',
    ASSET_PROTOCOL_LIST: apiBaseUrl + 'assetProtocols/list-all-active',
    LIST_ACCOUNT_ITEMS: apiBaseUrl + 'accountItems/list-for-fy',

    SALE_UPLOAD_DOCUMENT_HKTVM:apiBaseUrl + 'sales/upload-document-hktvm',
    DBASE_RETRIEVE_SALES_FULFILLMENT_CALENDAR: apiBaseUrl + 'dbase/retrieve-sales-fulfillment-calendar',
    PICKLIST_GENERATE_FROM_WAYBILL_SLOTS: apiBaseUrl + 'picklists/generate-from-waybill-slots',
    PICKLIST_RETRIEVE: apiBaseUrl + 'picklists/retrieve',
    PICKLIST_RETRIEVE_ITEMS_BY_CLASSIFICATION: apiBaseUrl + 'picklists/retrieve-items-by-classification',
    PICKLIST_UPDATE_ITEM_QTY_INCREMENTAL: apiBaseUrl + 'picklists/update-pick-item-qty-incremental',
    PICKLIST_CLOSE_BATCH: apiBaseUrl + 'picklists/close-batch', 
    WAYBILL_AUTO_GTIN_SCAN: apiBaseUrl + 'waybills/auto-gtin-scan', 
    DBASE_DOWNLOAD_WAYBILLS: apiBaseUrl + 'dbase/download-waybills',
    DBASE_DOWNLOAD_FILE: apiBaseUrl + 'dbase/download-file',
    DBASE_PURGE_TRANSACTIONS: apiBaseUrl + 'dbase/purge-transactions',
    WAYBILL_SET_PRINTED: apiBaseUrl + 'waybills/set-printed',       
}